<template>
  <section class="offers">
    <h4 class="offers__title pb-8">
      My Offers
    </h4>

    <div class="row ">
      <div class="col-md-4">
        <div class="card-offer card-offer-mini card-offer-tab wavebg">
          <div class="card-offer__head-btn">
            <div class>
              <span class="card-offer-id">ID: 16</span>
              <h5 class="card-offer-heading">
                RevShare
              </h5>
            </div>
            <i class="el-icon-arrow-right" />
          </div>
        </div>
        <div class="card-offer card-offer-mini card-offer-tab wavebg">
          <div class="card-offer__head-btn">
            <div class>
              <span class="card-offer-id">ID: 16</span>
              <h5 class="card-offer-heading">
                RevShare
              </h5>
            </div>
            <i class="el-icon-arrow-right" />
          </div>
        </div>
        <div class="card-offer card-offer-mini card-offer-tab wavebg">
          <div class="card-offer__head-btn">
            <div class>
              <span class="card-offer-id">ID: 16</span>
              <h5 class="card-offer-heading">
                RevShare
              </h5>
            </div>
            <i class="el-icon-arrow-right" />
          </div>
        </div>
      </div>

      <div class="col-md-8">
        <div class="card-offer pb-16 mb-2 wavebg">
          <div class="card-offer__head-id">
            <div>
              <span class="card-offer-id">ID: 16</span>
              <h5 class="offers__title">
                RevShare
              </h5>
            </div>
            <button class="btn btn-primary btn-sm card-offer__btn-r">
              Get Links
            </button>
          </div>
          <div class="card-offer-content !tw-flex">
            <div class="card-offer__col card-offer__cup">
              <p class="card-offer__col-title">
                Daily Cap
              </p>
              <span class="card-offer__col-val">Not Set</span>
            </div>
            <div class="card-offer__col card-offer__hold">
              <p class="card-offer__col-title">
                Hold
              </p>
              <span class="card-offer__col-val">Not Set</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style lang="scss">
// vue3-migration -- '@/assets/theme/common-page-styles.scss'
// @import 'src/assets/theme/default/components/styles-loaders';

</style>
